<template>
  <div>
    <div  style="height: 800px">

    </div>
          <div class="geologica">testtTTTTTTTTTTTTTTTTTTTTTTTT</div>

  </div>

</template>

<script setup>


</script>

<style scoped>
</style>
